import React from "react";
import { Button, Container } from "react-bootstrap";
import "./CheckOutForm.css";
import { Link } from "react-router-dom";
const CheckOutForm = () => {

  return (
    <div>
      <Container>
        {/* breadcrumb area begin  */}
        <ul className="d-flex m-0 p-0 py-3 border-bottom">
          <li className="fs-5 text-secondary fw-light">
            <Link to="/">Home</Link>/
          </li>
          <li className="fs-5 text-secondary fw-light">
            <Link to="/">Products</Link>/
          </li>
          <li className="fs-5 text-secondary fw-light">
            <span>Home</span>
          </li>
        </ul>
        {/* breadcrumb area begin  */}

        <div className="row py-3">
          <div className="col-12 col-md-12 col-lg-8 col-xl-8">
            <h4 className="fw-light">Billing Address</h4>
            <div className="checkout-form-container mt-5">
              <form>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <label htmlFor="FirstName">First Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name=""
                        id="FirstName"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <label htmlFor="LastName">Last Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name=""
                        id="LastName"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-3">
                      <label htmlFor="LastName">Company Name(Optional)</label>
                      <input
                        className="form-control"
                        type="text"
                        name=""
                        id="LastName"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-3">
                      <label htmlFor="LastName">Street Address</label>
                      <input
                        className="form-control"
                        type="text"
                        name=""
                        id="LastName"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <label htmlFor="LastName">Town/City</label>
                      <input
                        className="form-control"
                        type="text"
                        name=""
                        id="LastName"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <label htmlFor="LastName">State/Country</label>
                      <input
                        className="form-control"
                        type="text"
                        name=""
                        id="LastName"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <label htmlFor="LastName">Postal Code/ZIP</label>
                      <input
                        className="form-control"
                        type="text"
                        name=""
                        id="LastName"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <label htmlFor="LastName">Phone Number</label>
                      <input
                        className="form-control"
                        type="text"
                        name=""
                        id="LastName"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-3">
                      <label htmlFor="LastName">Email Address</label>
                      <input
                        className="form-control"
                        type="text"
                        name=""
                        id="LastName"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="col-12 col-md-12 col-lg-4 col-xl-4">
            <h4 className="fw-light">Your Order</h4>
            <div className="checkout-order-form">
              <div className="d-flex align-items-center justify-content-between border-bottom pb-2">
                <span>Products</span>
                <span>Price</span>
              </div>
              <div className="py-2">
                <div className="d-flex my-2 align-items-center justify-content-between">
                  <span>1.Womens Skirt</span>
                  <span>$ 135.44</span>
                </div>
                <div className="d-flex my-2 align-items-center justify-content-between">
                  <span>2.Womens Skirt</span>
                  <span>$ 135.44</span>
                </div>
                <div className="d-flex my-2 align-items-center justify-content-between">
                  <span>3.Womens Skirt</span>
                  <span>$ 135.44</span>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between border-top py-2">
                <span>Sub-total</span>
                <span>$ 450.89</span>
              </div>
              <div className="d-flex align-items-center justify-content-between border-top py-2">
                <span>Shipping</span>
                <span>Free</span>
              </div>
              <div className="d-flex align-items-center justify-content-between border-top py-2">
                <span className="fs-5">Total</span>
                <span>$ 450.89</span>
              </div>
              <div className="payment-option">
                <h4 className="fw-light pb-2 border-bottom border-light">Payment Option</h4>
                <div>
                  <div className="my-2 bg-light p-2 rounded">
                    <input type="radio" value="Male" name="gender" /> Stripe
                  </div>
                  <div className="my-2 bg-light p-2 rounded">
                    <input type="radio" value="Female" name="gender" /> Paypal
                  </div>
                  <div className="my-2 bg-light p-2 rounded">
                    <input type="radio" value="Other" name="gender" /> Cash On Delivery
                  </div>
                </div>
              </div>
              <Button variant="light" className="border p-2 mt-3 w-100">Shop Again</Button>
              <Button variant="dark" className="border p-2 mt-3 w-100">Place Order</Button>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CheckOutForm;
